import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider, useSettings } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Home from "./pages/Home";
import ExperiencesList from "./pages/ExperiencesList";
import ExperienceDetail from "./pages/ExperienceDetail";
import BookingPage from "./pages/BookingPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import TicketView from "./pages/TicketView";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminExperiences from "./pages/admin/AdminExperiences";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminCoupons from "./pages/admin/AdminCoupons";
import ValChat from "./components/ValChat";
import BenovaLogo from "./components/BenovaLogo";

function BrandSplash() {
  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 100,
        background: "var(--bn-bg, #0A0A0A)",
        display: "flex", alignItems: "center", justifyContent: "center",
        animation: "bnFadeIn 200ms ease-out",
      }}
      data-testid="brand-splash"
    >
      <BenovaLogo color="var(--bn-text, #F5F3EC)" accent="var(--bn-accent, #C9B98A)" size="xl" />
    </div>
  );
}

function PublicGate({ children }) {
  // Gate public pages on the first load so we never flash default settings.
  // The ThemeProvider initialises `loaded` to true if a localStorage cache exists,
  // so returning visitors never see the splash.
  const { loaded } = useSettings();
  const location = useLocation();
  if (!loaded && location.pathname !== "/payment-success") {
    return <BrandSplash />;
  }
  return children;
}

function PublicShell({ children }) {
  return (
    <PublicGate>
      {children}
      <ValChat />
    </PublicGate>
  );
}

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicShell><Home /></PublicShell>} />
              <Route path="/experiencias" element={<PublicShell><ExperiencesList /></PublicShell>} />
              <Route path="/experiencia/:slug" element={<PublicShell><ExperienceDetail /></PublicShell>} />
              <Route path="/reservar/:id" element={<PublicShell><BookingPage /></PublicShell>} />
              <Route path="/payment-success" element={<PublicShell><PaymentSuccess /></PublicShell>} />
              <Route path="/ticket/:id" element={<PublicShell><TicketView /></PublicShell>} />

              {/* Hidden admin */}
              <Route path="/val-benova-admin-2026/login" element={<AdminLogin />} />
              <Route path="/val-benova-admin-2026" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="experiencias" element={<AdminExperiences />} />
                <Route path="cupones" element={<AdminCoupons />} />
                <Route path="ajustes" element={<AdminSettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
